export default "__VITE_ASSET__9abe123e__"